var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col"},[_vm._t("default"),_vm._v(" "),_c('div',{staticClass:"card card-fluid"},[_c('div',{staticClass:"card-body"},[_c('disciplines-table',{attrs:{"science":_vm.science}})],1)])],2)}
var staticRenderFns = []

export { render, staticRenderFns }